module.exports = __webpack_public_path__ + "img/about1.5863de27.svg";